import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      try {
        const rr = await api.post("/auth/refresh");
        localStorage.setItem("pb_token", rr.data.access_token);
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch {
        localStorage.removeItem("pb_token");
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const handleAuth = (data) => {
    localStorage.setItem("pb_token", data.access_token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => handleAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => handleAuth((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pb_token");
    setUser(false);
  };
  const updateSettings = async (payload) => {
    const r = await api.put("/auth/settings", payload);
    setUser(r.data);
    return r.data;
  };

  return <Ctx.Provider value={{ user, login, register, logout, updateSettings, refresh, applyAuth: handleAuth }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
